import Vue from 'vue'
export default {
  namespaced: true,
  state: () => ({
    clinics: {}
  }),
  getters: {
    clinics: state => Object.values(state.clinics),
    byId: state => id => state.clinics[id]
  },
  mutations: {
    set (
      state,
      {
        id,
        partner,
        logo,
        name,
        city_id,
        address,
        phones,
        services,
        website,
        email,
        facebook,
        description
      }
    ) {
      if (!state.clinics[id]) {
        Vue.set(state.clinics, id, {})
      }
      Vue.set(state.clinics[id], 'id', id)
      Vue.set(state.clinics[id], 'partner', partner)
      Vue.set(state.clinics[id], 'logo', logo)
      Vue.set(state.clinics[id], 'name', name)
      Vue.set(state.clinics[id], 'city_id', city_id)
      Vue.set(state.clinics[id], 'address', address)
      Vue.set(state.clinics[id], 'phones', phones)
      Vue.set(state.clinics[id], 'services', services)
      Vue.set(state.clinics[id], 'website', website)
      Vue.set(state.clinics[id], 'email', email)
      Vue.set(state.clinics[id], 'facebook', facebook)
      Vue.set(state.clinics[id], 'description', description)
    },
    reset (state) {
      state.clinics = {}
    }
  }
}
